import { DEFAULT_LANGUAGE, LS_LANGUAGE_KEY } from "@onesolution/constants";

export function formatFrontDate(dateString: string | Date) {
	try {
		const lang = JSON.parse(
			localStorage.getItem(LS_LANGUAGE_KEY) || `"${DEFAULT_LANGUAGE}"`,
		);
		const convertedDate = new Date(dateString?.toString());

		if (!convertedDate || convertedDate.toString() === "Invalid Date")
			return "";

		return convertedDate.toLocaleDateString(lang, {
			month: "short",
			day: "2-digit",
			year: "numeric",
		});
	} catch (_) {
		return "";
	}
}
